
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/work-assistant/ai-for-engineering",
      function () {
        return require("private-next-pages/work-assistant/ai-for-engineering.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/work-assistant/ai-for-engineering"])
      });
    }
  